/**
 * LocalStorage manager for custom tokens
 * Stores tokens added by users via paste address
 */

const CUSTOM_TOKENS_KEY = 'little_rabbit_custom_tokens';

export const customTokenStorage = {
  /**
   * Get all custom tokens from localStorage
   */
  getAll: () => {
    try {
      const stored = localStorage.getItem(CUSTOM_TOKENS_KEY);
      return stored ? JSON.parse(stored) : [];
    } catch (error) {
      console.error('Error reading custom tokens:', error);
      return [];
    }
  },

  /**
   * Add a new custom token
   */
  add: (token) => {
    try {
      const tokens = customTokenStorage.getAll();
      
      // Check if token already exists
      const exists = tokens.find(
        t => t.address.toLowerCase() === token.address.toLowerCase()
      );
      
      if (exists) {
        // Update existing token
        const updated = tokens.map(t => 
          t.address.toLowerCase() === token.address.toLowerCase() ? token : t
        );
        localStorage.setItem(CUSTOM_TOKENS_KEY, JSON.stringify(updated));
        return updated;
      }
      
      // Add new token
      const updated = [...tokens, { ...token, isCustom: true, addedAt: Date.now() }];
      localStorage.setItem(CUSTOM_TOKENS_KEY, JSON.stringify(updated));
      return updated;
    } catch (error) {
      console.error('Error adding custom token:', error);
      return customTokenStorage.getAll();
    }
  },

  /**
   * Remove a custom token by address
   */
  remove: (address) => {
    try {
      const tokens = customTokenStorage.getAll();
      const filtered = tokens.filter(
        t => t.address.toLowerCase() !== address.toLowerCase()
      );
      localStorage.setItem(CUSTOM_TOKENS_KEY, JSON.stringify(filtered));
      return filtered;
    } catch (error) {
      console.error('Error removing custom token:', error);
      return customTokenStorage.getAll();
    }
  },

  /**
   * Find a token by address
   */
  find: (address) => {
    const tokens = customTokenStorage.getAll();
    return tokens.find(
      t => t.address.toLowerCase() === address.toLowerCase()
    );
  },

  /**
   * Clear all custom tokens
   */
  clear: () => {
    try {
      localStorage.removeItem(CUSTOM_TOKENS_KEY);
      return [];
    } catch (error) {
      console.error('Error clearing custom tokens:', error);
      return [];
    }
  }
};
